<template>
  <div class="stage">
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
export default {}
</script>
